import { createApiClient } from 'Network/ApiClient';

export const ActivityAxiosInstance = createApiClient('user/');



